<template>
  <transition name="fade" appear>
    <header class="Header">
      <div class="Header_logo">
        <a class="mouseover mouseover-simple" href="https://www.laphase5.com" target="_blank">
          <svg id="logo" class="Header_logo" :class="{ 'Header_logo_white': $route.name == 'game' }" viewBox="0 0 80 29.3">
            <g>
              <path id="Shape" class="st0" d="M0 .3h2c.6 0 .6 0 .7.6v24.5c0 1.5-.2 1.3 1.2 1.3H16c.6 0 .7 0 .7.6 0 1.8.2 1.5-1.4 1.5H.1C0 19.2 0 9.7 0 .3z"/>
              <path id="Shape_1_" class="st0" d="M52.3 5h-5.1c-.6 0-.6 0-.7.6l-.3 3c-.1.6-.1 1.3-.2 1.9 0 .3.1.4.5.3.7-.3 1.4-.5 2.2-.6 1.9-.4 3.6-.2 5.4.6 2.7 1.2 4 3.3 4.6 6.1.3 1.5.3 2.9.1 4.4-.2 2-1 3.9-2.5 5.4-1.3 1.2-2.8 2.1-4.6 2.3-2.1.3-4.1.4-6.2-.4-2.7-1-4.6-2.7-5.5-5.3-.2-.6-.3-1.4-.4-2-.1-.3.1-.5.4-.5h4.9c.3 0 .4.1.5.4.2.5.4 1.1.6 1.6.2.5.6.9 1.1 1.2 2.5 1.5 5.2.3 5.9-2.1.4-1.6.5-3.2-.1-4.8-.5-1.3-1.4-2.1-2.8-2.4-.9-.2-1.7-.2-2.5 0s-1.5.5-2 1c-.3.3-.6.4-1 .3-1.1-.3-2.3-.6-3.4-.9-.6-.2-.7-.4-.6-1 .1-1 .2-1.9.4-2.9.1-.8.2-1.7.3-2.5.1-.6.2-1.2.2-1.8.1-.8.1-1.7.2-2.5.1-1.2.2-2.3.4-3.5 0-.3.2-.5.5-.5h15c.6 0 .7.1.7.7v3.5c-.2.4-.3.4-.8.4h-5.2z"/>
              <path id="Shape_2_" class="st0" d="M18.7 14.6v-13-.8c0-.3.2-.5.5-.5h.6c3.1 0 6.2-.1 9.4 0 2.2.1 4.3.7 6.1 2.1 1.7 1.3 2.4 3 2.8 5 .1.5.2 1.1.2 1.6-.1 1.3-.3 2.6-.8 3.9-.4.9-1 1.6-1.7 2.2-1.4 1.2-3.1 1.8-4.9 2.1-.8.1-1.6.2-2.5.2h-5.8c-1.2 0-1.1-.1-1.1 1.1v9.4c0 1.1.1 1-1.1 1-.5 0-1-.1-1.5-.1 0-.5-.1-1-.1-1.5-.1-4.4-.1-8.6-.1-12.7zm2.7-5.8v5.4c0 1.1-.1 1 1 1 2.3-.1 4.6.2 6.8-.2.7-.1 1.4-.1 2.1-.2 1.9-.5 3.3-1.7 4-3.6.5-1.5.4-3.1 0-4.6-.4-1.5-1.4-2.4-2.7-3.2-1.5-.9-3.2-.9-4.8-1-1.8-.1-3.7 0-5.5 0-.9 0-.9 0-.9.9v5.5z"/>
              <path id="arrow-logo" class="st0" d="M80 14.6c-.1.1-.1.2-.2.2l-.4.4-13.6 13.6c-.1.1-.2.3-.4.4-.1.1-.3.1-.4 0-.4-.4-.9-.8-1.3-1.3-.2-.2-.1-.3 0-.5l.5-.5 5.2-5.2c2.2-2.2 4.4-4.3 6.6-6.4l.5-.5c.2-.2.2-.3 0-.5l-.5-.5C72.1 10 68.1 6 64.2 2.1c-.7-.7-.8-.6 0-1.4 1-1 1-1 1.9 0l5.2 5.2c2.7 2.6 5.4 5.2 8 7.8.2.2.4.4.5.6.1.1.2.2.2.3z"/>
            </g>
          </svg>
        </a>
      </div>

      <transition name="scale" appear>
        <div @click="$emit('openHelp')" class="Header_backstage mouseover" v-if="$route.name == 'game' && withHelp">Aide <i class="far fa-anchor"></i></div>
      </transition>

      <transition name="scale" appear>
        <div class="Audio" @click="toggleAudio" v-if="withHelp">
          <div v-if="withAudio" key="withAudio"><i class="fad fa-volume-up"></i></div>
          <div v-else key="withoutAudio"><i class="fad fa-volume-slash"></i></div>
        </div>
      </transition>
    </header>
  </transition>
</template>

<script>

export default {
  methods: {
    
  },
  data () {
    return {
      withHelp: true,
      withAudio: true,
      lastAudioState: null
    }
  },
  methods: {
    toggleAudio()
    {
      if(this.withAudio)
        Howler.mute(true)
      else
        Howler.mute(false)
      
      this.withAudio = !this.withAudio
    },
    onResume()
    {
      this.withAudio = this.lastAudioState
      Howler.mute(!this.withAudio)
    },
    onPause()
    {
      this.lastAudioState = this.withAudio
      this.withAudio = false
      Howler.mute(true)
    }
  },
  beforeDestroy()
  {
    window.removeEventListener('blur', this.onPause, false)
    window.removeEventListener('focus', this.onResume, false)
  },
  mounted()
  {
    window.addEventListener('blur', this.onPause, false)
    window.addEventListener('focus', this.onResume, false)
  }
}
</script>

<style lang="stylus" scoped>

  .Header

    position fixed
    top 50px
    left 60px
    z-index 30
    pointer-events none
    touch-action none
    width calc(100vw - 120px)

    @media $small

      top 30px
      left 30px
      z-index 5
      width calc(100vw - 60px)

    .Audio

      pointer-events auto
      touch-action auto
      cursor pointer
      position fixed
      bottom 50px
      color white
      right 60px
      padding 20px 20px
      font-size 25px

      @media $small

        bottom 10px
        right 10px
        font-size 20px


    &_backstage

      font-size 16px
      color white
      position absolute
      top 50%
      right 0px
      pointer-events auto
      touch-action auto
      cursor pointer
      transform translateY(-50%)
      transition transform 0.45s $back
      backface-visibility hidden

      &:hover

        transform translateY(-50%) rotate(8deg)


      i

        font-size 21px
        margin-left 8px
        position relative
        top 2px

    &_logo

      width 90px
      fill $blue
      cursor pointer
      pointer-events auto
      touch-action auto
      transition fill 1s $ease, transform 0.45s $back
      backface-visibility hidden

      &:hover

        transform rotate(-4deg)

      &_white

        fill white

</style>
